var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('div',[_vm._v(_vm._s(item.auftragStatus))]),_vm._v(" "),_c('AuftragOverview',{ref:"AuftragOverview",refInFor:true,attrs:{"auftrag":item},on:{"refresh-list":_vm.refresh}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143b53fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/vue/components/internal/StatusList.vue
// module id = null
// module chunks = 